import { selectorInert } from '../utils/a11y';

export default function () {
  const selectorDomInert = document.querySelectorAll(selectorInert);
  const dialogSuccess = document.getElementById('modalSuccessMessage');
  const dialogError = document.getElementById('modalErrorMessage');
  const form = document.querySelector('#contact-form');
  const buttonSubmit = document.querySelector('#buttonSubmit');
  const buttonsClose = document.querySelectorAll('.modal-btn-close');

  function modalClose() {
    selectorDomInert.forEach((dom) => {
      dom.removeAttribute('inert');
    });
  }

  buttonsClose.forEach((button) => {
    button.addEventListener('click', modalClose);
  });

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      let result;

      try {
        toggleStateButton(true, buttonSubmit);

        const response = await fetch('https://b2ohnx7uvsegc6cabm7tctr2iy0vvamw.lambda-url.ca-central-1.on.aws/', {
          method: 'POST',
          body: formData
        });
        result = await response.json();
      } catch (error) {
        dialogError.showModal();

        selectorDomInert.forEach((dom) => {
          dom.setAttribute('inert', '');
        });

        document.querySelector('#dialogErrorTitle').focus();
      }

      // success
      if (result?.success) {
        dialogSuccess.showModal();

        selectorDomInert.forEach((dom) => {
          dom.setAttribute('inert', '');
        });

        resetInputs();
        return;
      }

      // error
      dialogError.showModal();
    });
  }

  function resetInputs() {
    const inputs = document.querySelectorAll('input[type="text"], input[type="email"], textarea');

    inputs.forEach((input) => {
      input.value = '';
    });

    toggleStateButton(false, buttonSubmit);
  }

  function toggleStateButton(state, button) {
    const buttonSubmitLabel = button.querySelector('.label');
    const buttonSubmitSpinner = button.querySelector('.spinner');

    if (state) {
      buttonSubmitLabel.classList.add('!hidden');
      buttonSubmitSpinner.classList.remove('!hidden');
      button.setAttribute('disabled', '');
      return;
    }

    buttonSubmitLabel.classList.remove('!hidden');
    buttonSubmitSpinner.classList.add('!hidden');
    button.removeAttribute('disabled');
  }
}
